import { IStepSixModel } from './IStepSixModel';

const StepSixModelInitialState: IStepSixModel = {
  codePosti: null,
  mobile: null,
  address: null,
  city: null,
  province: null,
};

export default StepSixModelInitialState;
